import { MygaShellFooter } from "@/apps/charm/lib/myga/shell-footer";
import { MygaShellHeader } from "@/apps/charm/lib/myga/shell-header";
import { Spinner } from "@/ui/shadcn/component/spinner";

export function MygaLoading() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="mx-auto flex min-h-80 w-full max-w-3xl flex-col items-center justify-center gap-4 px-5 py-12 text-center">
      <Spinner
        className="size-6 text-gf-ink-700 motion-reduce:animate-none"
        aria-hidden="true"
      />
      <p className="text-gf-caption font-medium text-gf-text-muted">
        Getting things ready
      </p>
    </div>
  );
}

export function MygaLoadingScreen() {
  return (
    <div className="goldfinch-ds flex min-h-dvh flex-col bg-gf-bg-section font-gf-sans text-gf-text-strong">
      <MygaShellHeader review={false} />
      <main className="mx-auto w-full max-w-7xl flex-1 px-3 py-4 sm:px-8 sm:py-10">
        <MygaLoading />
      </main>
      <MygaShellFooter comparing={false} className="px-3 sm:px-8" />
    </div>
  );
}
